import { render, staticRenderFns } from "./EmpSettingsUsers.vue?vue&type=template&id=c0ec336c&"
import script from "./EmpSettingsUsers.vue?vue&type=script&lang=js&"
export * from "./EmpSettingsUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports